/* eslint-disable no-else-return */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { withModalContext } from '@jutro/components';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { PolicyService } from 'gw-capability-gateway';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { FormModalPopover } from 'ml-components-platform-react';
import { gatewayMessages } from 'gw-capability-gateway-react';
import { GatewayClaimService } from 'gw-capability-gateway-claim';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { MLLineTypeUtil, MLLocalDateUtil } from 'ml-portals-util-js';
import { MLTagManagerService } from 'ml-portals-services-react';
import MLClaimDetailPopup from 'gw-capability-gateway-react/Components/MLClaimDetailPopup/MLClaimDetailPopup';


import appConfig from 'app-config';
import MLPolicySummaryDetailsComponent from 'gw-capability-gateway-react/Components/MLPolicySummaryDetailsComponent/MLPolicySummaryDetailsComponent';

import claimMessages from '../../Claims.messages';
import metadata from './PolicyClaims.metadata.json5';
import policyClaimMessages from './PolicyClaims.messages.js';
import styles from './PolicyClaims.module.scss';

import { TranslatorContext, withIntl } from '@jutro/legacy/locale';

const PERSONAL_AUTO = 'PersonalAuto';
const PERSONAL_UMBRELLA = 'PersonalUmbrella';
const STATUS = 'status';
const PA_LOB_PATH = 'personalAuto';
const UMB_LOB_PATH = 'personalUmbrella';
const HOP_LOB_PATH = 'homeowners';
const CLAIM_DETAILS_MODAL_OVERRIDE = 'customHeaderTitle';
class PolicyClaimsWithoutModalContext extends Component {
    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        fromAccountLanding: PropTypes.shape({
            policyDetailsData: PropTypes.shape({
                policyResponse: PropTypes.shape({
                    policyNumber: PropTypes.string,
                    account: PropTypes.shape({
                        policySummaries: PropTypes.array
                    }),
                    product: PropTypes.shape({
                        productCode: PropTypes.string
                    }),
                    latestPeriod: PropTypes.shape({
                        canceled: PropTypes.string
                    })
                })
            })
        }).isRequired,
        intl: PropTypes.func.isRequired,
        isOpen: PropTypes.bool
    };

    static contextType = TranslatorContext;

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            claimResponse: '',
            IsEmptyResponse: false,
            claimDataTable: '',
            policy: undefined
        };
    }

    getClaimDataTable = (claimsData) => {
        const { intl } = this.props;
        const { isClaimsConsolidationEnabled } = this.state;
        let claimsArrayResult = claimsData;
        claimsArrayResult = claimsArrayResult.map((claimInfo) => {
            const claims = {
                claimNumber: claimInfo.claimNumber,
                dateOfLoss: intl.formatDate(new Date(claimInfo.lossDate), { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'UTC' }),
                lossType: isClaimsConsolidationEnabled ? claimInfo.claimType_Ext : this.getDescriptionFromLossType(claimInfo.lossType_ML),
                description: this.generateClaimDescription(claimInfo),
                status: claimInfo.status_ML,
            };
            return claims;
        });
        claimsArrayResult = _.orderBy(claimsArrayResult, ["lossDate"], ["desc"]);
        this.setState({
            claimDataTable: claimsArrayResult
        });
    };

    getDescriptionFromLossType = (lossTypeCode) => {
        const { viewModelService } = this.props;
        const translator = this.context;

        if (lossTypeCode === undefined) {
            return translator(policyClaimMessages.draftClaim);
        }

        const claimLossTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('ClaimLossType_ML')
        const lossTypeName = claimLossTypeList.getCode(lossTypeCode).name;
        const lossType = translator({
            id: lossTypeName,
            defaultMessage: lossTypeName
        });
        return lossType;
    }

    generateClaimDescription = (claimData) => {
        const {
            isClaimsConsolidationEnabled
        }=this.state;
        if (isClaimsConsolidationEnabled === true) {
            return claimData.claimDescription;
        }
        else {
            // eslint-disable-next-line max-len
            if (claimData.product_ML.productCode === PERSONAL_AUTO || (claimData.product_ML.productCode === PERSONAL_UMBRELLA && claimData.vehicle_ML)) {
                const vehicle = claimData.vehicle_ML;
                if (vehicle) {
                    return this.getVehicleDetailsString(vehicle);
                }
                return '-';
            }

            // Umbrella description
            if (claimData.businessActivity_ML) {
                const { viewModelService } = this.props;
                const businessActivityTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('PUPBusinessDescription_ML')
                const businessActivityName = businessActivityTypeList.getCode(claimData.businessActivity_ML).name;
                const translator = this.context
                const businessActivity = translator({
                    id: businessActivityName,
                    defaultMessage: businessActivityName
                });
                return businessActivity;
            }

            if (claimData.locationAddress_ML !== undefined) {
                return claimData.locationAddress_ML;
            }

            // Fall back as draft claims may not have any info at all.
            return '-';
        }
    }

    getVehicleDetailsString = (vehicle) => {
        if (vehicle.year && vehicle.make && vehicle.model) {
            const formattedMake = _.startCase(_.lowerCase(vehicle.make));
            const formattedModel = _.startCase(_.lowerCase(vehicle.model));
            const trim = (vehicle.trim_ML) ? vehicle.trim_ML : '';
            return `${vehicle.year} ${formattedMake} ${formattedModel} ${trim}`;
        }

        return '-';
    }

    componentDidMount = () => {
        const { authHeader, fromAccountLanding } = this.props;
        const { policyNumber } = fromAccountLanding.policyDetailsData.policyResponse;
        this.setState({
            policy: fromAccountLanding.policyDetailsData.policyResponse.account.policySummaries.filter((policy) => policyNumber === policy.policyNumber)[0]
        });
        PolicyService.getClaimsConsolidationEnabled(authHeader).then((response) => {
            this.setState({
                isClaimsConsolidationEnabled: response
            });
        });
        PolicyService.getPolicyClaimsForAllStatuses(policyNumber, authHeader).then((response) => {
            if (_.isEmpty(response)) {
                this.setState({
                    IsEmptyResponse : true
                });
                return;
            }
            this.getClaimDataTable(response);
            this.setState({
                claimResponse: response,
                isLoading: false
            });
        });
    };

    getCell = (item, index, property) => {
        const translator = this.context;
        const toolTipMessage = {
            dateOfLoss: translator(claimMessages.dateOfLoss),
            status: translator(claimMessages.status)
        };

        let label = item[property.id];
        if (property.id === STATUS) {
            label = _.upperCase(item[property.id]);
        }
        return <span title={toolTipMessage[property.id]}>{label}</span>;
    };

    // TODO: move to a util function as it is shared by all tabs in PE policy details
    getCurrentTermPolicies = (policyResponse) => {
        const policies = [];
        const periodsOrderedFromLast = _.orderBy(policyResponse.periods, ['createTime_ML'], ['desc']);
        const flteredPeriods = periodsOrderedFromLast.find((period) => {
            const currentDate = new Date().setHours(0, 0, 0, 0);
            return currentDate >= MLLocalDateUtil.localDate2Date(period.effective_ML) && currentDate <= MLLocalDateUtil.localDate2Date(period.expiration_ML);
        }) || policyResponse.latestPeriod;
        policies.push(flteredPeriods);
        return policies;
    };

    getLink = (item, index, property) => {
        const translator = this.context;
        const toolTipMessage = {
            claimNumber: translator(claimMessages.claimNumber)
        };
        return (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link to='#' title={toolTipMessage[property.id]} className={styles.claimLink} onClick={() => this.showModal(item[property.id])}>
                {item[property.id]}
            </Link>
        );
    };

    getPathForLob = (claim) => {
        if (claim.policy.policyType === PERSONAL_AUTO) {
            return PA_LOB_PATH;
        }
        if (claim.policy.policyType === PERSONAL_UMBRELLA) {
            return UMB_LOB_PATH;
        }
        return HOP_LOB_PATH;
    }

    getVehiclesInvolvedInIncident = (vehicleIncidents) => {
        const vehicles = []
        vehicleIncidents.forEach((vehicleIncident) => {
            if (vehicleIncident.vehicle !== undefined) {
                vehicleIncident.vehicle.vehicleLossParty_ML = vehicleIncident.vehicleLossParty_ML;
                vehicles.push(vehicleIncident.vehicle);
            }
        });

        return vehicles;
    }

    isPersonalUmbrella = (policy) => {
        return policy?.policyLines?.some((line) => MLLineTypeUtil.isPersonalUmbrella(line.lineOfBusinessCode));
    };

    showModal = (claimNumber) => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Claim Details`);
        const claimResponse = this.state.claimResponse;
        const getClaimData = claimResponse.filter((claimData) => claimData.claimNumber === claimNumber);
        const claimDetailUrl = getClaimData[0].claimDetailURL;
        const isPersonalUmbrella = this.isPersonalUmbrella(this.state.policy);
        const policyType = getClaimData[0].product_ML.productCode;
        const { authHeader } = this.props;
        const translator = this.context;
        PolicyService.getClaimsConsolidationEnabled(authHeader).then((isA360ServiceEnabled) => {
            if (isA360ServiceEnabled === true) {
                if (!isPersonalUmbrella) {
                    window.open(claimDetailUrl,'_blank');
                    return;
                }
                const componentProps = {
                    simpleMessage: translator(policyClaimMessages.popupBody),
                    closeSimpleMessage: false
                };
                return this.props.modalContext.showModal(
                    <FormModalPopover {...componentProps} />
                );
            } else {
                GatewayClaimService.getClaimDetail(claimNumber, authHeader).then((res) => {
                    let policyVehicles;
                    let claimVehicles;
                    let vehicleIncidents;

                    if (policyType === 'PersonalAuto') {
                        policyVehicles = res.policy.lobs.personalAuto.vehicles;
                        claimVehicles = res.lobs.personalAuto.vehicles;
                        vehicleIncidents = res.lobs.personalAuto.vehicleIncidents;
                    }
                    if (policyType === 'PersonalUmbrella') {
                        claimVehicles = res.lobs.personalUmbrella.vehicles;
                        vehicleIncidents = res.lobs.personalUmbrella.vehicleIncidents;
                    }
                    const componentProps = {
                        CustomComponent: MLClaimDetailPopup,
                        title: translator(policyClaimMessages.claimDetail),
                        additionalPEStyle: CLAIM_DETAILS_MODAL_OVERRIDE,
                        showFooterOnCustomComponent: true,
                        showActionButton: false,
                        cancelBtnLabel: translator(policyClaimMessages.closeBtn),
                        overrideProps: {
                            adjuster: res.adjuster,
                            claimContacts: res.claimContacts,
                            claimDetail: res,
                            payments: res.payments_Ext,
                            policyCoverages: res.policy.coverages,
                            reserves: res.reserves_ML,
                            policyType,
                            policyVehicles,
                            policy: res.policy,
                            claimVehicles,
                            vehicleIncidents
                        }
                    };
                    return this.props.modalContext.showModal(
                        <FormModalPopover {...componentProps} />
                    );
                });
            }
        });
    }

    render() {
        const {
            claimDataTable, claimResponse, isLoading, policy, IsEmptyResponse
        } = this.state;

        const {
            policyDetailsData: {
                policyResponse
            }
        } = this.props;

        const translator = this.context;

        //if (isLoading) {}

        const overrides = {
            claimDataTable: {
                data: claimDataTable
            },
            noDataMessageContainer: {
                visible: _.isEmpty(claimResponse) || IsEmptyResponse
            },
            noDataMessage: {
                value: translator(gatewayMessages.noClaimsResult)
            },
            paidColumnTitle: {
                visible: appConfig.persona === 'producer' || appConfig.persona === 'csr'
            },
            netIncurredColumnTitle: {
                visible: appConfig.persona === 'producer' || appConfig.persona === 'csr'
            },
            policySummaryDetailsComponent: {
                policies: this.getCurrentTermPolicies(policyResponse),
                dtoInfo: 'edge.capabilities.gateway.policy.dto.PolicyPeriodDTO',
                totalFees: policyResponse.totalChanges_Ext,
                itemizedFees: policyResponse.feesCosts_Ext,
                displayAlternativeTemplate: false
            }
        };
        const resolvers = {
            resolveClassNameMap: styles,
            resolveComponentMap: {
                MLPolicySummaryDetailsComponent
            },
            resolveCallbackMap: {
                getCell: this.getCell,
                getAccount: this.getAccount,
                getLink: this.getLink,
                showModal: this.showModal
            }
        };
        const claimPage = <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;
        return (
            <div>
                {claimPage}
            </div>
        );
    }
}

const PolicyClaims = withModalContext(PolicyClaimsWithoutModalContext);

export const PolicyClaimsComponent = PolicyClaims;
export default withIntl(withViewModelService(withAuthenticationContext(PolicyClaims)));
